export default __webpack_public_path__ + "static/media/MetricDown.9365dd85.svg";